import { getAbsoluteURL } from '@tgg/util';

import { OrganisationSchemaTypes } from './StandardPage.types';

export function getOrganisationSchemaForPage(
    name: string,
    url: string,
    links: string[],
): OrganisationSchemaTypes {
    const absoluteLogoSource = getAbsoluteURL('/ywnqh/images/tgg_logo.svg');

    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: name ?? '',
        url: url ?? '',
        logo: absoluteLogoSource,
        founder: 'John Treharne',
        foundingDate: '2008-01-01',
        sameAs: links ?? [],
    };
}
